// extracted by mini-css-extract-plugin
export default {"description":"SecondScreen_description__l55Y8","row":"SecondScreen_row__zD1Q8"};